export class SetCancelledRefresh {
  static readonly type = '[Browser Refresh] Set Cancelled Refresh';
  constructor(
    public data: {
      hasUserCancelledRefresh: boolean;
      cancelledVersion?: number;
    },
  ) {}
}
